import util from '@/utils'

const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,

  brandList: state => state.base.brandList,
  categoryList: state => state.base.categoryList,
  supplierList: state => state.base.supplierList,
  memberLevels: state => state.base.memberLevels,
  deliveryList: state => state.base.deliveryList,
  regionList: state => state.base.regionList,
  regionMap: state => util.recursiveToTree(state.base.regionList, '', 'parentCode', 'regionCode')
}

export default getters
